<app-loading-spinner *ngIf="isLoading" [inline]="1"></app-loading-spinner>
<nav class="subnav">
  <h2>Overview</h2>
</nav>

<div class="container container-inner">
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="card mt-3 bg-dark text-white mb-3">
        <img
        src="/assets/img/module-drink-guide-470x260.jpg"
        class="card-img-top card-img-top-fh img-mobile"
        alt="A hand held out blocking a wine glass"
      />
      <img
      src="/assets/img/module-drink-guide-930x260.jpg"
        class="card-img-top card-img-top-fh img-desktop"
        alt="A hand held out blocking a wine glass"
      />


        <div class="card-body text-center">
          <h3 class="card-title card-title-lg">Drink Guide For Surgery</h3>
          <p class="card-text">Welcome to Drink Guide! The module that helps you to monitor your alcohol intake within limits that will help you to prepare for surgery.</p>
        </div>
      </div>
      <button
        class="btn btn-primary w-100"
        [routerLink]="['/modules', 'drinking-guide', 'tracker']"
      >
        Alcohol Tracker
      </button>
    </div>
    <div class="col-12" *ngIf="userData">
      <h4 class="text-center mt-4 mb-2">Module Task List</h4>

      <div class="card bg-light">
        <div class="card-body">
          <ul class="link-list">
            <li>
              <a [routerLink]="['/modules', 'drinking-guide', 'resources']">
                <span class="circle-num">1</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label"
                  >Welcome to Drink Guide</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'drinking-guide', 'resources', 32]">
                <span class="circle-num">2</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">Why it's important to limit my alcohol intake for surgery</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'drinking-guide', 'resources', 33]">
                <span class="circle-num">3</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">
                  How to limit my alcohol intake for surgery</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/modules', 'drinking-guide', 'resources', 34]">
                <span class="circle-num">4</span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label"> How to record and monitor my Drink Guide progress for surgery</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a  [routerLink]="['/modules', 'drinking-guide', 'tracker']">
                <span class="circle-num"
                  ><fa-icon [icon]="['far', 'repeat']"></fa-icon
                ></span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'martini-glass']"></fa-icon
                ></span>
                <span class="link-label"
                  >Add Entries to the drink tracker</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a   (click)="journalService.onShowJournal('drinkGuide')">
                <span class="circle-num"
                  ><fa-icon [icon]="['far', 'repeat']"></fa-icon
                ></span>
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'book']"></fa-icon
                ></span>
                <span class="link-label"
                  >Drink Guide Journal</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
